import moment from 'moment';

import defaultMessages from './en-us.json';
import { contentSharingLibMessages } from '@keap-web/content-sharing-lib';
import { sharedUiMessages } from '@keap-web/shared-ui';

import {
    createI18n,
    getSupportedLocale,
} from '@keap-web/keap-i18n';

const i18n = createI18n({
    messages: {
        'en-us': {
            ...contentSharingLibMessages,
            ...defaultMessages,
            ...sharedUiMessages,
        },
    },
});

const loadLocale = async () => {
    const locale = getSupportedLocale(navigator.language.toLowerCase());

    if (locale !== 'en-us') {
        const { rtl } = await import(`./locales/${locale}.js`);

        i18n.global.locale = locale;
        moment.locale(locale);

        if (rtl) {
            document.documentElement.setAttribute('dir', 'rtl');
        }
    }

    return locale;
};

export { i18n, loadLocale };
